import {
  buttonsLabels,
  roles,
  subRoles,
  subRolesCheckbox,
} from "../../../utils/constants";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { HiOutlineMail } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { customers } from "../../../engine/customerConfig";
import { t } from "i18next";
import { userHasLevel } from "../../../engine/AuthRoute";

export const InstitutionsUserForms = ({ user, isFirst, institutionId }) => {
  const { user: userId } = useParams();
  const { t } = useTranslation(); // Initialize useTranslation

  const [subRoleitemDisabled, setSubRoleitemDisabled] = useState([]);

  const {
    info: { firstname, lastname, genre, phone, title },
    status,
    email,
  } = user;

  useEffect(() => {
    if (
      user.subRoles.length > 0 &&
      user.subRoles.includes(subRoles.institutionAdmin)
    ) {
      setSubRoleitemDisabled([
        subRoles.institutionDemander,
        subRoles.institutionFinance,
      ]);
    }
  }, [user.subRoles]);

  return [
    {
      parentLabel: "",
      children: [
        {
          label: t("institutionsUserForms.lastname"),
          name: "info.lastname",
          value: lastname,
          type: "input",
          required: true,
          col: 24,
        },
        {
          label: t("institutionsUserForms.firstname"),
          name: "info.firstname",
          value: firstname,
          required: true,
          type: "input",
          col: 24,
        },
        {
          label: t("institutionsUserForms.title"),
          name: "info.title",
          watchValues: [
            subRoles.institutionDemander,
            subRoles.institutionAdmin,
            subRoles.institutionFinance,
          ],
          watchRequiredCondition:
            process.env.CUSTOMER_ID !== customers.sosticino,
          watch: "subRoles",
          value: title,
          type: "input",
          required: process.env.CUSTOMER_ID !== customers.sosticino,
          col: 24,
        },
        {
          label: t("institutionsUserForms.email"),
          required: true,
          name: "email",
          normalize: value => value && value.toLowerCase(),
          addonBefore: <HiOutlineMail />,
          value: email,
          type: "email",
          col: 24,
        },
        {
          label: t("institutionsUserForms.phone"),
          name: "info.phone",
          addonBefore: "+41",
          value: phone,
          type: "input",
          col: 24,
        },
        userId !== "new"
          ? {
              label: t("institutionsUserForms.access"),
              name: "status",
              value: status,
              required: true,
              type: "select",
              selectContent: [
                { label: t("active"), value: "active" },
                { label: t("inactive"), value: "inactive" },
                { label: t("archived"), value: "archived" },
              ],
              col: 24,
            }
          : null,
      ],
    },
    {
      parentLabel: t("institutionsUserForms.roles"),
      children: [
        {
          label: "",
          name: "subRoles",
          value: user.subRoles,
          type: "checkbox",
          required: true,
          onChange: props => {
            const { ref, value } = props;
            if (ref !== undefined) {
              if (value.includes(subRoles.institutionAdmin)) {
                ref.current.setFieldsValue({
                  subRoles: [
                    subRoles.institutionAdmin,
                    subRoles.institutionDemander,
                    subRoles.institutionFinance,
                  ],
                });

                setSubRoleitemDisabled([
                  subRoles.institutionDemander,
                  subRoles.institutionFinance,
                ]);
              } else {
                setSubRoleitemDisabled([]);
              }
            }
          },
          itemDisabled: subRoleitemDisabled,
          checkboxs: subRolesCheckbox(),
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("header.institutions"),
      // visible: userHasLevel({
      //   only: {
      //     [roles.admin]: "c", //
      //     [roles.permanance]: "c", //
      //   },
      // }),
      visible: userHasLevel({
        only: {
          [roles.admin]: "r", //
          [roles.permanance]: "r", //
        },
      }),
      children: [
        {
          label: t("header.institutions"),
          name: "institutions",
          value: userId === "new" ? [institutionId] : user.institutions,
          visible: userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          // value: userHasLevel({
          //   not: {
          //     [roles.institution]: "", //
          //   },
          // })
          //   ? []
          //   : user.institutions,
          // onChange: ({ value }) => {
          //   setDataForm({
          //     ...dataForm,
          //     institution: value,
          //   });
          // },
          multiple: true,
          search: true,
          type: "dynamic-select",
          required: true,
          endPoint: "institutions",
          itemsCallBack: (institutions, form) => {},
          itemCallback: item => {
            return {
              key: item._id,
              label: `${item.name}`,
              value: item._id,
            };
          },
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label:
            userId === "new"
              ? t("institutionsUserForms.createUser")
              : t("institutionsUserForms.save"),
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};
